import { API_SERVICE } from "./root";
import { UserServiceClient } from "@/pbjs/external/user/user_grpc_web_pb";
import { AuthServiceClient } from "@/pbjs/external/auth/auth_grpc_web_pb";
import { TicketServiceClient } from "@/pbjs/external/ticket/ticket_grpc_web_pb";
import { NxExtenManageServiceClient } from "@/pbjs/external/dialer/nxExtenManage_grpc_web_pb";
import { CollectionServiceClient } from "@/pbjs/external/ticket/collection_grpc_web_pb";
import { DialerServiceClient } from "@/pbjs/external/dialer/dialer_grpc_web_pb";
import { LogServiceClient } from "@/pbjs/external/log/log_grpc_web_pb";
import { HrServiceClient } from "@/pbjs/external/hr/hr_grpc_web_pb";


// const url: string = "https://envoy.okredito.console.mx.fg-example.com";
const url: string = API_SERVICE;

let client: any = new UserServiceClient(url, null, null);
let authorClient: any = new AuthServiceClient(url, null, null);
let ticketClient: any = new TicketServiceClient(url, null, null);
let nxExtenManageClient: any = new NxExtenManageServiceClient(url, null, null);
let collectionServiceClient: any = new CollectionServiceClient(url, null, null);
let dialerClient: any = new DialerServiceClient(url, null, null);
let logClient: any = new LogServiceClient(url, null, null);
let hrClient: any = new HrServiceClient(url, null, null);


export {
  client,
  authorClient,
  ticketClient,
  nxExtenManageClient,
  collectionServiceClient,
  dialerClient,
  logClient,
  hrClient
};
